import { Select } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useContext } from "react";
import ProjectContext from "./ProjectContext";

// Hardcoded list of owners
const OWNERS = [
  { id: 6, name: "Alex" },
  { id: 194, name: "Jade" },
];

const OwnerView = () => {
  const { originalProject, saveProject } = useContext(ProjectContext);

  function handleOwnerChange(event) {
    const ownerId = parseInt(event.target.value);
    saveProject({
      variables: {
        id: originalProject.id,
        ownerId: ownerId,
      },
      onCompleted: () => {
        Alert("success", "Project owner updated.");
      },
    });
  }

  return (
    <div className="card">
      <h5>Product Owner</h5>

      <div className="mt-2 -mx-[2px]">
        <Select
          value={originalProject.owner?.id || "0"}
          onChange={handleOwnerChange}
        >
          <option value="0" disabled>
            Not Set
          </option>
          {OWNERS.map((owner) => (
            <option key={owner.id} value={owner.id}>
              {owner.name}
            </option>
          ))}
        </Select>
      </div>
    </div>
  );
};

export default OwnerView;
